import React from "react";
import { Container, Row } from "reactstrap";
import LeftSideContent from "./LeftSideContent";
import RightSideContent from "./RightSideContent";
import Section from "./Section";

const MyProfile = () => {
  document.title = "My Profile | JobSpace - Job Listing Template | Themesdesign";
  return (
    <React.Fragment>
      <div style={{marginTop : "50px"}}></div>
      <section className="section">
        <Container>
          <Row>
            <LeftSideContent />
            <RightSideContent />
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
};

export default MyProfile;
